var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFire = function SvgFire(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    fillRule: "evenodd",
    d: "M8.157 2.762C7.934 4.4 7.283 5.674 5.72 7.533c-1.988 2.365-2.398 3.234-2.386 5.053.008 1.097.148 1.762.532 2.527.576 1.144 2.121 2.505 3.349 2.948 1.13.408 1.495.346.635-.108-1.605-.845-2.065-2.766-1.119-4.672l.395-.794.293.595c.162.328.464.719.674.869.346.248.38.164.38-.951 0-1.283.508-2.46 1.444-3.342.61-.576.853-.565.853.036 0 .735.387 1.47 1.542 2.932 1.664 2.106 1.636 3.818-.085 5.123-.893.677-.624.755.749.216 3.753-1.473 4.765-5.453 2.478-9.747l-.582-1.092-.4.703c-.76 1.34-.789 1.336-1.073-.115-.326-1.658-.985-2.929-2.112-4.066-.796-.804-2.47-1.981-2.817-1.981-.09 0-.231.493-.313 1.095",
    clipRule: "evenodd"
  })));
};
export default SvgFire;